import { ImperialAnthropometryEntryForm } from "apps/web/src/components/AnthropometryEntry/Form/ImperialAnthropometryForm";
import { UseFormReturn } from "react-hook-form";
import { AnthropometryEntryType } from "../../../components/AnthropometryEntry/Form/AnthropometryEntryFormSchema";
import { AnthropometryEntryFormAlertDisplayHeader } from "./AnthropometryEntryFormAlertDisplayHeader";

interface CreateImperialAnthropometryEntryFormProps {
  form: UseFormReturn<AnthropometryEntryType>;
}

export const CreateImperialAnthropometryEntryForm = ({ form }: CreateImperialAnthropometryEntryFormProps) => (
  <>
    <AnthropometryEntryFormAlertDisplayHeader />
    <ImperialAnthropometryEntryForm form={form} />
  </>
);
